import axios from 'axios';

// ---------------------------------------------------------------------------
// DYNAMIC API URL CONFIGURATION
// Automatically switches between localhost and production
// ---------------------------------------------------------------------------
const isLocal = window.location.hostname === "localhost";
export const API_URL = isLocal 
  ? 'http://localhost:5279/api' 
  : 'https://dmsserver.nsfdcdigital.in/api';

// --- EXISTING FETCH FUNCTIONS ---
export const fetchLoans = () => axios.get(`${API_URL}/inquiry/loans`);
export const fetchSkills = () => axios.get(`${API_URL}/inquiry/skills`);

// UPDATED: Now points to the correct new Workshop route
export const fetchWorkshops = () => axios.get(`${API_URL}/Workshop/all`);
export const deleteWorkshop = (id) => axios.delete(`${API_URL}/Workshop/${id}`);

// --- NEW: EXHIBITION API ---
export const fetchExhibitionNominations = async () => {
    return await axios.get(`${API_URL}/Exhibition/all`);
};

// --- USER OPERATIONS ---
export const fetchUsers = () => axios.get(`${API_URL}/user/all`);
export const createUser = (userData) => axios.post(`${API_URL}/user/create`, userData);
export const updateUser = (id, userData) => axios.put(`${API_URL}/user/${id}`, userData);
export const deleteUser = (id) => axios.delete(`${API_URL}/user/${id}`);

// --- AUTHENTICATION ---
export const adminLogin = (credentials) => axios.post(`${API_URL}/auth/admin/login`, credentials);

// --- NEW: DMS USER MANAGEMENT (SUPER ADMIN ONLY) ---
export const fetchDmsUsers = (headers) => axios.get(`${API_URL}/dmsuser/all`, { headers });
export const createDmsUser = (userData, headers) => axios.post(`${API_URL}/dmsuser/create`, userData, { headers });
export const deleteDmsUser = (id, headers) => axios.delete(`${API_URL}/dmsuser/${id}`, { headers });
export const updateDmsUser = (id, userData, headers) => axios.put(`${API_URL}/dmsuser/${id}`, userData, { headers });

// --- DMS LOGIN ---
export const dmsLogin = (credentials) => axios.post(`${API_URL}/dmsuser/login`, credentials);